import type { ProductRoomPriceRankFormModel } from "../../../type";
import type { ServerModel } from "../type";

type Props = {
	serverModel: ServerModel;
};

export const convertToInputModel = ({ serverModel }: Props) => {
	const { roomPriceRank } = serverModel;

	const inputModel: ProductRoomPriceRankFormModel["InputModel"] = {
		hotelID: roomPriceRank.hotelID,
		ranks: roomPriceRank.ranks.map((rank) => {
			return {
				color: rank.color,
				priceRankID: rank.priceRankID,
				isStopSelling: rank.isStopSelling || false,
				name: rank.name,
				rooms: rank.rooms,
			} satisfies ProductRoomPriceRankFormModel["InputModel"]["ranks"][0];
		}),
	} satisfies ProductRoomPriceRankFormModel["InputModel"];

	return inputModel;
};
